import { configureStore } from '@reduxjs/toolkit';
import mfaSetupReducer  from './MFA-setup-slice';
import creditReducer from './Credit-slice';
export default configureStore({
  reducer: {
    MFA: mfaSetupReducer,
    creditSupply: creditReducer
  },
});